import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function SettingsElasticSearchReindexRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.SettingsElasticSearchReindex', {
		url: '/admin/elasticsearch/reindex',
		controllerAs: 'vm',
		controller: SettingsElasticSearchReindexCtrl,
		templateUrl: '/ng/hub/Settings/ElasticSearch/Reindex/SettingsElasticSearchReindexCtrl.html?' + window.BUILD,
		permission: ['all'],
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Settings/ElasticSearch/Reindex/SettingsElasticSearchReindexCtrl.css'),
			$title: () => 'Synchronize ElasticSearch with Database',
		},
	});
}

export class SettingsElasticSearchReindexCtrl {
	constructor($timeout, Api, Identity) {
		'ngInject';
		// save injections
		this.$timeout = $timeout;
		this.Api = Api;
		// setup
		this.hubs = Identity.hubsInThisAccount();
		this.models = ['Posts', 'Stories'];
	}

	loadCounts(model, hub) {
		if (!hub.models) {
			hub.models = {};
		}
		if (!hub.models[model]) {
			hub.models[model] = {};
		}
		hub.models[model].loading = true;
		hub.models[model].counts = false;
		this.Api.get('/nosql/imports/counts', { hub_id: hub.id, model }).then(counts => {
			hub.models[model].loading = false;
			hub.models[model].counts = counts;
		});
	}

	reindex(model, hub) {
		if (!hub.models) {
			hub.models = {};
		}
		if (!hub.models[model]) {
			hub.models[model] = {};
		}
		hub.models[model].isReindexing = true;
		hub.models[model].reindexingStatus = 'Re-indexing... ';
		this.Api.submitJob('POST', '/nosql/imports', { hub_id: hub.id, model }).then(response => {
			response.onJobComplete(details => {
				const data = JSON.parse(details.response_body);
				this.$timeout(() => {
					hub.models[model].isReindexing = false;
					if (!data.success) {
						hub.models[model].reindexingStatus = 'Error reindexing.';
						return;
					}
					const status = `Re-indexed ${data.num_records} records(s) in ${data.num_batches} batch(es).`;
					hub.models[model].reindexingStatus = status;
					if (hub.models[model].counts) {
						// post counts were loaded before; reload them
						this.loadCounts(model, hub);
					}
				});
			}, 2500);
		});
	}
}
